import React from 'react'
import { Header } from '../../components/ads/ad-blood-testing/Header'

const BloodTestingLombardPage = () => {
  return (
    <div style={{ overflow:'hidden'}}>
        <Header/>
    </div>
  )
}

export default BloodTestingLombardPage